var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30.9 23.7",
    style: {
      enableBackground: "new 0 0 30.9 23.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000026885351644197605660000005689310050262961852_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    className: "st0",
    d: "M26.5,0H4.3C1.9,0,0,1.9,0,4.3l0,0v15c0,2.4,1.9,4.3,4.3,4.4c0,0,0,0,0,0h22.2 c2.4,0,4.3-1.9,4.3-4.3l0,0v-15C30.9,2,29,0,26.5,0C26.6,0,26.5,0,26.5,0z M4.3,2.4h22.2c1.1,0,1.9,0.8,1.9,1.9v1.5h-26V4.3 C2.4,3.3,3.3,2.4,4.3,2.4z M26.5,21.3H4.3c-1,0-1.9-0.9-1.9-1.9v-8.7h26v8.7C28.4,20.4,27.6,21.3,26.5,21.3L26.5,21.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsActive);
export default __webpack_public_path__ + "static/media/cards-active.641b63d477892d9c2edd2c56291dc28c.svg";
export { ForwardRef as ReactComponent };